import React from 'react';
import styled from 'styled-components';
import { IIcon } from './types';

const SVG = ({ className = 'icon' }: IIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="94"
      height="94"
      viewBox="0 0 94 94"
      fill="none"
      className={className}>
      <path
        d="M21.824 52.929C17.7889 47.4186 15.3753 40.6502 15.3753 33.3126C15.3753 14.9447 30.3199 0 48.6877 0C67.0556 0 82 14.9447 82 33.3126C82 51.6806 67.0554 66.6252 48.6876 66.6252C41.3501 66.6252 34.581 64.2113 29.0707 60.1762L8.747 79.747L1.5 72.5L21.824 52.929ZM48.6876 56.3751C61.405 56.3751 71.75 46.0301 71.75 33.3126C71.75 20.5952 61.405 10.2501 48.6876 10.2501C35.9702 10.2501 25.6252 20.5952 25.6252 33.3126C25.6252 46.0301 35.9703 56.3751 48.6876 56.3751Z"
        fill="#7A7F82"
      />
      <Mask id="mask0_1151_4197" maskUnits="userSpaceOnUse" x="41" y="41" width="53" height="53">
        <path d="M94 41H41V94H94V41Z" fill="white" />
      </Mask>
      <g mask="url(#mask0_1151_4197)">
        <path
          d="M67.4996 93.9995C82.135 93.9995 93.999 82.1345 93.999 67.4996C93.999 52.8643 82.135 41 67.4996 41C52.8643 41 41 52.8643 41 67.4996C41 82.1345 52.8643 93.9995 67.4996 93.9995Z"
          fill="#FCB514"
        />
        <path
          d="M70.6813 69.8398C70.553 70.8695 70.3941 71.9385 69.9657 72.7785C69.7605 73.1805 69.465 73.5065 69.08 73.7545C68.6949 74.0025 68.177 74.1265 67.5263 74.1265C66.8756 74.1265 66.3578 74.0025 65.9727 73.7545C65.5877 73.5065 65.2922 73.1805 65.087 72.7785C64.4803 71.5915 64.4803 69.9505 64.3012 68.6496C64.0714 66.9773 63.8833 65.2983 63.7378 63.6163C63.5483 61.4232 63.4311 59.2249 63.3863 57.0243C63.3475 55.1162 63.0856 53.0163 64.0848 51.2933C64.393 50.7628 64.825 50.3344 65.3817 50.0091C65.9376 49.6845 66.6533 49.5211 67.5263 49.5211C68.3994 49.5211 69.1098 49.6882 69.6583 50.0218C70.206 50.3553 70.6343 50.7926 70.9425 51.3314C71.2507 51.8709 71.4597 52.4835 71.5716 53.1678C72.1163 56.5049 71.9813 59.9248 71.6126 63.2731C71.4253 64.9752 71.1686 66.6684 70.8821 68.3563C70.8037 68.8182 70.747 69.3241 70.6828 69.8398H70.6813ZM71.738 81.2155C71.738 82.6705 71.3694 83.7445 70.6336 84.4385C69.8971 85.1315 68.8613 85.4785 67.5256 85.4785C66.1899 85.4785 65.1019 85.1315 64.3661 84.4385C63.6296 83.7455 63.2617 82.6705 63.2617 81.2155C63.2617 79.7595 63.6296 78.6725 64.3661 78.0045C65.1019 77.3375 66.1548 77.0035 67.5256 77.0035C68.8964 77.0035 70.0038 77.3375 70.6978 78.0045C71.391 78.6725 71.738 79.7425 71.738 81.2155Z"
          fill="white"
        />
      </g>
      <circle cx="47.5" cy="20.5" r="4.5" fill="#7A7F82" />
      <path
        d="M9.00082 79.5C7.50083 80.5 4.00073 81.4 2.00073 79C0.0635345 76.6754 0.676649 74.0775 1.50075 72.5L9.00082 79.5Z"
        fill="#7A7F82"
      />
    </svg>
  );
};

const Mask = styled.mask`
  mask-type: luminance;
`;

export default SVG;
